async function formOnSubmit(event) {
    event.preventDefault();
    let postEvent;
    if (event.target.elements.reportName) postEvent = {
        reportName: event.target.elements.reportName.value
    };
    else postEvent = {
        eventPayload: JSON.parse(event.target.elements.event.value),
        eventType: event.target.elements.eventType.value,
        eventSource: event.target.elements.eventSource ? event.target.elements.eventSource.value : '/Collectibles/NCF',
        eventSubject: event.target.elements.eventSubject.value
    };
    console.log(postEvent);
    const resp = await fetch("/", {
        method: "POST",
        body: JSON.stringify(postEvent),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    });
    $('#modalBody').html(`<pre><code>${JSON.stringify(await resp.json(), undefined, 2)}</code></pre>`);
    // @ts-ignore
    $('#exampleModalCenter').modal('show');
    return false;
}
globalThis.formOnSubmit = formOnSubmit;

//# sourceMappingURL=index.38fe5cbe.js.map
